import { combineEpics } from 'redux-observable';
import { FetchHomePageOptions, FetchDefaultHomePage, FETCH_HOME_PAGE_OPTIONS, FETCH_DEFAULT_HOME_PAGE } from '../actions/NavConfigActions';
import { getFetchHomePageOptionsRequestStatus, getFetchDefaultHomePageRequestStatus } from '../selectors/RequestStatusSelector';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import NavConfigAPI from '../api/NavConfigAPI';
import { RequestEpicDescriptor, requestEntity } from 'settings-ui-lib/utils/epics';
const fetchHomePageOptions = requestEntity(new RequestEpicDescriptor({
  apiFunction: NavConfigAPI.getHomePageOptions,
  initiatingActionType: FETCH_HOME_PAGE_OPTIONS,
  requestStatusSelector: getFetchHomePageOptionsRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchHomePageOptions
}));
const fetchDefaultHomePage = requestEntity(new RequestEpicDescriptor({
  apiFunction: NavConfigAPI.getDefaultHomePage,
  initiatingActionType: FETCH_DEFAULT_HOME_PAGE,
  requestStatusSelector: getFetchDefaultHomePageRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchDefaultHomePage
}));
export default combineEpics(fetchHomePageOptions, fetchDefaultHomePage);